import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SVVideo from "../components/SVVideo";
import SVInfoSub from "../components/Usuarios/SVInfoSub";
import { getFirestore, getDoc, doc } from "firebase/firestore/lite";

function SVShowsPage({ usuario }) {
  const { id, linkId } = useParams();
  const [show, setShow] = useState();

  useEffect(() => {
    const db = getFirestore();
    getDoc(doc(db, "Shows", id)).then((res) => {
      setShow({ ...res.data(), id: id });
    });
  }, [id]);

  return (
    <>
      {usuario.isSubscriptionActive ? (
        show &&
        (show.isActivated || usuario.isAdmin) && (
          <SVVideo show={show} linkId={linkId} />
        )
      ) : (
        <SVInfoSub />
      )}
    </>
  );
}

export default SVShowsPage;
